import { render, staticRenderFns } from "./company-override-banner.vue?vue&type=template&id=7670f229&scoped=true&"
import script from "./company-override-banner.vue?vue&type=script&lang=js&"
export * from "./company-override-banner.vue?vue&type=script&lang=js&"
import style0 from "./company-override-banner.vue?vue&type=style&index=0&id=7670f229&scoped=true&lang=scss&"
import style1 from "./company-override-banner.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7670f229",
  null
  
)

export default component.exports